import { App } from 'vue'
import GwmBridge from '@gwm/bridge'
import mockBridge from './mock'
import customConfig from './customConfig'

const mockConfig = {
  enable: import.meta.env.VITE_NODE_ENV === 'local' || !!import.meta.env.VITEST,
  config: mockBridge,
}

const bridgeObj = GwmBridge({
  vue: {
    version: 3,
  },
  mock: mockConfig,
  config: customConfig,
})

const install = (app: App<Element>) => {
  bridgeObj.install(app)
}

export const bridge = bridgeObj.bridge

export default {
  install,
}
